"use scrict";

global.$ = require("jquery");
var MobileDetect = require('mobile-detect');
global.md = new MobileDetect(window.navigator.userAgent);
global.MOBILE = md.mobile();

const { detect } = require('detect-browser');
global.browser = detect();

var mainWidth;

global.remToPx = function(x){
  return (parseInt($('html').css('font-size')) * x);
}

global.TOUCH = (('ontouchstart' in window) ||
  (navigator.maxTouchPoints > 0) ||
  (navigator.msMaxTouchPoints > 0));

global.TABLET = navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /MacIntel/.test(navigator.platform);

import guide from './modules/guide';

global.isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

global.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

$(function(){
  window.maxvh = 0;
  vh();
  initPage();
});

window.runKeksi = function(){
  var doCookie = true;
  // $('.notis').slideDown(300);

  if(window.localStorage.getItem('amosrexgg-notis-cookie')){
    var diff = (Date.now() - parseInt(window.localStorage.getItem('amosrexgg-notis-cookie'))) / 1000;
    let day = 86400;
    let week = 604800;
    if(diff < week) {
      doCookie = false;
    }
    if(doCookie) {
      $('.keksi').addClass('in');
    }
  } else {
    setTimeout(function(){
      $('.keksi').addClass('in');
    }, 2000);
  }

  $('.noti--close').click(function(e){
    e.preventDefault();
    $(this).parents('.noti').removeClass('in');
    window.localStorage.setItem('amosrexgg-notis-cookie',Date.now());
  });
}


function initPage() {
  console.log('initpage');

  if(JSON.parse(localStorage.getItem('amosrexgg-darkmode'))) {
    $('html').addClass('darkmode');
    $('.vx-toggle.toggle-darkmode').addClass('t');
  } else {
    $('html').removeClass('darkmode');
  }

  if(isSafari) {
    $('html').addClass('safari');
  }

  if(TABLET) {
    $('html').addClass('tablet');
  }

  binds();

  if($('html').hasClass('guide')) {
    window.guide = new guide();
  } else {
    $('html').addClass('show-header');
  }

  if(!window.isHome||window.homeconstructed){
    window.runKeksi();
  }
  setTimeout(function(){
    checkFirstView();
    $(window).trigger('scroll');
  }, 500);

  initSlides();

  initGalleries();

  initFooter();

  $(window).trigger('scroll');
}

function initGalleries() {
  $('.gallery--inner').unbind('scroll').scroll(function(){
    var prc = (($(this).scrollLeft()) / (this.scrollWidth - $(this).outerWidth())) * .7;
    
    var parRect = this.getBoundingClientRect();
    let range = parRect.width * .25;
    let sel = null;

    $(this).children('li').each(function(){
      let rect = this.getBoundingClientRect();
      if(rect.left < parRect.left + range && rect.right - range < parRect.right){
        sel = this;
      }
    });

    if(sel) {
      let idx = $(sel).index();
      $(this).siblings('.dots').children().removeClass('cur');
      $(this).siblings('.dots').children().eq(idx).addClass('cur');
    }
  });

  $('.gallery--inner').each(function(){
    var par = this;
    $(this).siblings('.dots').children('li').unbind('click').click(function(e){
      e.preventDefault();
      let idx = $(this).index();
      let pos = $(par).scrollLeft() + $(par).children().eq(idx).position().left;
      // console.log(pos);
      $(par).scrollLeft(pos);
      // $(par).animate({
        // 'scrollLeft' : pos
      // }, 200);
    });
  });

  $('.gallery--nav').click(function(e){
    e.preventDefault();
    if($(this).hasClass('right')){
      if($(this).siblings('.dots').find('.cur').next().length>0){
        $(this).siblings('.dots').find('.cur').next().click();
      } else {
        $(this).siblings('.dots').children().first().click();
      }
    } else if($(this).hasClass('left')){
      if($(this).siblings('.dots').find('.cur').prev().length>0){
        $(this).siblings('.dots').find('.cur').prev().click();
      } else {
        $(this).siblings('.dots').children().last().click();
      }
    }
  });
}

function initFooter(){
  $('.dome svg [fill]').attr('fill','#ffffff');

  window.allowDomeClick = true;

  var domeLen = $('.dome').length;
  // $('.dome').each(function(idx){
  //   let zIndex = Math.random() > .5 ? 0 : 1;
  //   let prc = -Math.random() * 20 - 5;
  //   // let height = parseFloat(100 - (Math.random() * 30));
  //   // let prc = -100 + ((100 / domeLen)*(idx+1));
  //   $(this).css({
  //     // 'height' : height+'%',
  //     // 'margin-left' : prc+'%',
  //     // 'z-index' : zIndex,
  //   });
  // });

  $('.dome--scroll--title').text($('.dome').first().attr('data-title'));

  if(window.innerWidth<=767){
    $('.dome--wrap').unbind('scroll click').scroll(function(){
      var prc = (($(this).scrollLeft()) / (this.scrollWidth - $(this).outerWidth())) * .7;
      $('.dome--scroll--line--area').css('left', prc*100+'%');

      var parRect = this.getBoundingClientRect();
      let range = parRect.width*.33;
      let sel = null;

      $('.dome--wrap .dome').each(function(){
        let rect = this.getBoundingClientRect();
        if(rect.left < parRect.left + range && rect.right - range < parRect.right){
          sel = this;
        }
      });

      if(sel) {
        $('.dome--scroll--title').text($(sel).attr('data-title'));
        $('.dome--wrap').attr('href',$(sel).attr('data-href'));
        $('.dome').not(sel).find('svg [fill]:not(ellipse)').attr('fill','#ffffff');
        $(sel).find('svg [fill]:not(ellipse)').attr('fill','#d3d3d3');
        $('.dome').not(sel).removeClass('sel');
        $(sel).addClass('sel');
      }
    }).click(function(e){
      e.preventDefault();
      e.stopPropagation();
      if(window.allowDomeClick){
        window.allowDomeClick = false;
        let href = $(this).attr('href');
        if(href) {
          if(href.indexOf('credits')<0) {
            window.location = href;
          } else {
            $('.dome.textpage-link').click();
          }
        }
      }
      clearTimeout(window.allowDomeClickTime);
      window.allowDomeClickTime = setTimeout(function(){
        window.allowDomeClick = true;
      }, 100);
    }).trigger('scroll');
  } else {

    $('.dome--scroll--title').text('');
    // desktop domes
    $('.dome--wrap').mouseleave(function(){
      $('.dome--scroll--title').text('');
      $('.dome--wrap').attr('href','#');
      $('.dome svg [fill]:not(ellipse)').attr('fill','#ffffff');
      $('.dome').removeClass('sel');
    });

    $('.dome').mouseenter(function(){
      var sel = this;
      $('.dome--scroll--title').text($(sel).attr('data-title'));
      $('.dome--wrap').attr('href',$(sel).attr('data-href'));
      $('.dome').not(sel).find('svg [fill]:not(ellipse)').attr('fill','#ffffff');
      $(sel).find('svg [fill]:not(ellipse)').attr('fill','#d3d3d3');
      $('.dome').not(sel).removeClass('sel');
      $(sel).addClass('sel');
    }).click(function(e){
      console.log('click');
      if(window.allowDomeClick){
        e.preventDefault();
        e.stopPropagation();
        let href = $(this).attr('data-href');
        if(href) {
          if(href.indexOf('credits')<0) {
            window.location = href;
          } else {
            $('.dome.textpage-link').click();
          }
        }
      }
    });
  }

  /*
  if(!TOUCH) {
    window.domeSpeed = 0;
    function domeMoveAnim(){
    // console.log('raf', window.domeSpeed);
      $('.dome--wrap').scrollLeft($('.dome--wrap').scrollLeft() + window.domeSpeed * 18);
      window.domeMove = requestAnimationFrame(domeMoveAnim);
    }
    $('.footer--domes').unbind('mouseenter mousemove mouseleave').mouseenter(function(){
      window.domeMove = requestAnimationFrame(domeMoveAnim);
      $('.dome--wrap').trigger('scroll');
      $('.dome--scroll--title').css('text-decoration','underline');
    }).mousemove(function(e){
      var domes = $('.footer--domes');
      var x = e.clientX - $(domes).offset().left;
      var w = $(domes).outerWidth();
      var prc = (-(w/2) + (x)) / (w/2);
      if(prc > 0 && prc <= 0.2) prc = 0;
      if(prc > 0 && prc > 0.2) prc -= .2;

      if(prc < 0 && prc >= -0.2) prc = 0;
      if(prc < 0 && prc < -.2) prc += .2;
      window.domeSpeed = prc;
      //console.log(prc);
    }).mouseleave(function(){
      cancelAnimationFrame(window.domeMove);
      $('.dome--scroll--title').css('text-decoration','');
      $('.dome [fill]').attr('fill','#ffffff');
      setTimeout(function(){
        $('.dome [fill]').attr('fill','#ffffff');
      }, 10);
    });

    setTimeout(function(){
      $('.dome [fill]').attr('fill','#ffffff');
    }, 100);
  }
  */

  // clearInterval(window.anim);
  // window.animProg = 0.0;
  // window.animDir = 1;
  // window.anim = setInterval(function(){
  //   var bfX = window.animProg * 0.0005 + 0.0,
  //   bfY = window.animProg * 0.02 + 0.02,
  //   bfStr = bfX.toString() + ' ' + bfY.toString();
  //   window.animProg += 0.005 * window.animDir;
  //   if(window.animProg >= 1) window.animDir = -1;
  //   if(window.animProg <= 0) window.animDir = 1;
  //   $('#feturbulence').get(0).setAttribute('baseFrequency', bfStr);
  // }, 20);
}

function initSlides(){
  if(window['guideanims']){
    for(var i=0; i<window['guideanims'].length; i++){
      window.clearInterval(window.guideanims[i]);
    }
  }
  window.guideanims = [];
  $('[data-duration]').each(function(idx){
    var id = $(this).attr('id');
    if(id==undefined) {
      id = $(this).parents('.imageset').attr('id');
    }
    var duration = $(this).attr('data-duration')*1000;

    var container = this;
    var interval_id = `intervals_${id}`;
    // window.clearInterval(window.guideanims[interval_id]);
    window.guideanims[idx] = setInterval(function(){
      var curAct = container.querySelector('.act');
      if(curAct){
        var next = curAct.nextElementSibling;
        if(!next) { next = container.querySelector('li'); }
        curAct.classList.remove('act');
        next.classList.add('act');
      }
    }, duration);
  });
}

function checkFirstView(){
  $('.wrap').css('opacity',1);

  $('[data-src]:not(.ok):not(.loading):visible, .image--guide img:not(.ok):not(.loading)').each(function(idx){
    if(this.getBoundingClientRect().top < window.innerHeight*1.5){
      let src = $(this).attr('data-src');
      var srcset = $(this).attr('data-srcset');
      $(this).addClass('loading');
      let t = $(this).get(0);
      var delay = $(this).attr('data-idx');
      if($(t).is('video')){
        t.onload = function(){
          setTimeout(function(){
            $(t).addClass('ok').removeClass('loading');
          }, delay * 100 + 50);
        }
        t.onloadeddata = function(){
          setTimeout(function(){
            $(t).addClass('ok').removeClass('loading');
          }, delay * 100 + 50);
        }
        t.src = src;
      } else {
        let img = new Image();
        if(img.complete) {
          console.log('img was complete');
          setTimeout(function(){
            $(t).addClass('ok').removeClass('loading');
          }, delay * 100 + 50);
        }
        img.onload = function(){
          // console.log('img load');
          setTimeout(function(){
            $(t).addClass('ok').removeClass('loading');
          }, delay * 100 + 50);
        }
        img.onloadeddata = function(){
          // console.log('img load');
          setTimeout(function(){
            $(t).addClass('ok').removeClass('loading');
          }, delay * 100 + 50);
        }
        img.src = src;
        t.src = src;
        if(srcset) img.srcset = srcset;
        if(srcset) t.srcset = srcset;
      }
    }
  });
}

function binds(){

  // $(window).unbind('scroll');
  console.log('binds');
  // ajax site

  $('.burger').click(function(e){
    e.preventDefault();
    $('html').toggleClass('nav-open');
  });

  $('.vx-toggle').click(function(e){
    e.preventDefault();
    $(this).toggleClass('t');
  });

  $('.vx-toggle.toggle-darkmode').click(function(){
    let newVal = !JSON.parse(localStorage.getItem('amosrexgg-darkmode'));
    localStorage.setItem('amosrexgg-darkmode', newVal);
    if(newVal) {
      $('html').addClass('darkmode');
    } else {
      $('html').removeClass('darkmode');
    }
  });

  $(window).scroll(function(){
    $('[data-src]:not(.ok):not(.loading):visible, .image--guide img:not(.ok):not(.loading)').each(function(){
      if(this.getBoundingClientRect().top < window.innerHeight * (MOBILE ? 1.5 : 3.0)){
        var src = $(this).attr('data-src');

        var srcset = $(this).attr('data-srcset');
        // if(!WEBP) {
        //   srcset = $(this).attr('data-srcset-jpeg');
        // }

        $(this).addClass('loading');

        var t = $(this).get(0);

        if($(this).is('video')) {
          // t = this;
          t.onload = function(){
            // console.log('img load');
            $(t).addClass('ok').removeClass('loading');
          }
          t.onloadeddata = function(){
            // console.log('img load');
            $(t).addClass('ok').removeClass('loading');
          }
          setTimeout(function(){
            t.src = src;
          }, 1);
        } else {
          var img = new Image();

          if(img.complete) {
            console.log('img was complete');
            $(t).addClass('ok').removeClass('loading');
          }
          img.onload = function(){
            console.log('img load');
            $(t).addClass('ok').removeClass('loading');
          }
          img.onloadeddata = function(){
            console.log('img load');
            $(t).addClass('ok').removeClass('loading');
          }

          img.src = src;
          t.src = src;

          if(srcset) img.srcset = srcset;
          if(srcset) t.srcset = srcset;
        }
      }
    });
  });
} // end binds

function vh(){
  window.vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${window.vh}px`);

  window.maxvh = window.innerHeight*0.01;
  document.documentElement.style.setProperty('--maxvh', `${window.maxvh}px`);
}

function resize(){
  let newMainWidth = $('main').outerWidth();
  if(newMainWidth!==mainWidth || !md.mobile()){
    vh();
  }
  mainWidth = newMainWidth;

  if((window.innerHeight*0.01) > window.maxvh){
    window.maxvh = window.innerHeight*0.01;
    document.documentElement.style.setProperty('--maxvh', `${window.maxvh}px`);
  }
}

$(window).resize(function(){
  resize();
});
